<dx-check-box
  [disabled]="disabled" [(value)]="value!"
  [text]="placeholder ? placeholder : ''"
  (valueChange)="onSelfChangeValue(value);"
  (onFocusIn)="(!!onFocusIn && onFocusIn())" (onFocusOut)="(!!onFocusOut && onFocusOut())"></dx-check-box>